import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import breakpointValues from "@store/Framework/Common/Utilities/breakpointValues";
import updateCssValue, { Operators } from "@store/Framework/Common/Utilities/updateCssValue";
import { GridPreset } from "@store/Framework/Types/Grid";
import { css } from "styled-components";

export const gridGapStyles = (
    horizontalGap: Array<string | 0 | null>,
    verticalGap?: Array<string | 0 | null> | null,
) => {
    const _horizontalGap = horizontalGap.map(x => updateCssValue(x, Operators.Divide, 2));
    const _verticalGap = verticalGap?.map(x => updateCssValue(x, Operators.Divide, 2)) ?? _horizontalGap;

    return css`
        > ${GridOffset} {
            width: auto !important;

            ${breakpointValues(
                _horizontalGap.map(x => (x ? `-${x}` : x)),
                ["margin-right", "margin-left"],
            )}

            ${breakpointValues(
                _verticalGap.map(x => (x ? `-${x}` : x)),
                ["margin-top", "margin-bottom"],
            )}

            > ${GridItemStyle} {
                ${breakpointValues(_horizontalGap, ["padding-right", "padding-left"])}
                ${breakpointValues(_verticalGap, ["padding-top", "padding-bottom"])}
            }
        }
    `;
};

export const gridPresetGapStyles = (preset: GridPreset) => {
    return css`
        ${gridGapStyles(preset.horizontal, preset.vertical)}
    `;
};
